// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@guestsupply/App/Components/Notify";
import { locationFinderStyles } from "@guestsupply/Overrides/Widgets/LocationFinder/LocationFinder";
import { color, mergeWithCss } from "@guestsupply/XDL/Utilities";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import { css } from "styled-components";

locationFinderStyles.selectedDealerDisplayBackToResultsGridItem = {
    width: 12,
};

locationFinderStyles.selectedDealerDisplayBackToResultsLink = {
    icon: {
        iconProps: {
            src: ChevronLeft,
        },
        position: "left",
    },
};

locationFinderStyles.selectedDealerDisplayGridItem = {
    width: 12,
};

locationFinderStyles.locationContentModal = {
    size: 650,
    cssOverrides: {
        modalTitle: css`
            padding: 10px 20px;
        `,
        modalContent: css`
            padding: 20px;
        `,
    },
};

locationFinderStyles.contentContainer = {
    css: css``,
};

locationFinderStyles.container = {
    gap: 20,
};

locationFinderStyles.topSectionGridItem = {
    width: 12,
};

locationFinderStyles.leftColumnGridItem = {
    width: [12, 12, 12, 4, 4],
};

locationFinderStyles.rightColumnGridItem = {
    width: [12, 12, 12, 8, 8],
};

locationFinderStyles.mapWrapper = {
    css: css`
        width: 100%;
        border: 1px solid ${color("common.border")};
    `,
};

// XNG-Changes: GSS-714
locationFinderStyles.locationSearchForm = {
    siteMessageResultsErrorText: {
        ...mergeWithCss(getNotifyStyle("warning"), {
            css: css`
                margin: 0;
                color: ${color("text.main")};
            `,
        }),
    },
};
